import React, { useEffect, useState } from "react";
import { Checkbox, FormSection, LightContainer } from "../../../components";
import "./caracteristicas.scss";

interface CaracteristicaInterface {
  id: number,
  nome: string,
};

export interface CaracteristicasInterface {
  grupo: string,
  caracteristicas: CaracteristicaInterface[],
};

interface CaracteristicaProps {
  caracteristicas: CaracteristicasInterface[],
  handleConsulta: any,
};

const Caracteristica: React.FC<CaracteristicaProps> = ({ caracteristicas, handleConsulta }) => {
  const [consulta, setConsulta] = useState<CaracteristicasInterface | any>({});
  const [depsOpen, setDepsOpen] = useState(true);
  const [selectedCaracteristicas, setSelectedCaracteristicas] = useState<Array<number>>([]);

  const handleCarateristica = (caracteristica: CaracteristicaInterface) => {
    
    const i = selectedCaracteristicas.findIndex((a) => a == caracteristica.id);
    if (i >= 0) {
      selectedCaracteristicas.splice(i, 1);
    } else {
      selectedCaracteristicas.push(caracteristica.id);
    }

    setSelectedCaracteristicas(selectedCaracteristicas);
    setConsulta({ ...consulta, caracteristicas: selectedCaracteristicas });
  };

  const getCaracteristicas = () => {
    return (
      <div className="caracteristicas-cards">
        {caracteristicas &&
          caracteristicas.length > 0 &&
          caracteristicas.map((item: CaracteristicasInterface, i: number) => {
            return (
              <LightContainer
                title={item && item.grupo}
              >
                {item &&
                    item.caracteristicas &&
                    item.caracteristicas.length > 0 &&
                    item.caracteristicas.map((caracteristica: CaracteristicaInterface, c: number) => {
                      return (
                        <Checkbox
                          // id={i}
                          key={i}
                          onChange={() =>
                            handleCarateristica(caracteristica)
                          }
                          checked={ selectedCaracteristicas && selectedCaracteristicas.includes( caracteristica.id )}
                          text={caracteristica.nome}
                        />
                      );
                    })}
              </LightContainer>
            );
          })}
      </div>
    );
  };

  useEffect(() => {
    handleConsulta(consulta);
  }, [consulta]);

  return (
    <div className="main-content">
      <FormSection
        title="Características"
      >
        <div className="global-input-container slide caracteristicas-grid">
          {caracteristicas && caracteristicas.length > 0 ? (
            getCaracteristicas()
          ) : (
            <div>Selecione uma raça antes de selecionar as características</div>
          )}
        </div>
      </FormSection>
    </div>
  );
}

export default Caracteristica